import { lazy } from 'react';

export const AuthPage = lazy(() =>
  import('./ui/AuthPage').then((module) => ({
    default: module.AuthPage,
  }))
);
